module.exports = __webpack_public_path__ + "media/images/emblems/Etziken-blason-0aa50d5862826d3ca5c02df5b2950513.png";